import React from 'react'

const FeatureTransformationDoc = () => {
  return (
    <div className='container'>
        <h1 className='text-light text-center'>Feature Transformation</h1>
      <p className='text-light'>
        A Feature Transformation MLGUI Web Tool is a user-friendly web-based interface that allows students and developers to easily perform feature transformations on their machine learning data. This type of tool typically includes a variety of pre-built transformation options, such as scaling, normalization, and encoding, as well as the ability to create custom transformations using code. The goal of this type of tool is to make it easier for students and developers to quickly and easily manipulate their data in order to improve the performance of their machine learning models.
    </p>
    </div>
  )
}

export default FeatureTransformationDoc
